const orderSearch = document.querySelector('#order-search');
const orderDateFilter = document.querySelector('#order-date-filter');

function addOrUpdateQueryParam(param, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value);
    window.location.href = url.toString();
}

orderSearch?.addEventListener('input', function() {
    addOrUpdateQueryParam('search', orderSearch.value);
});

orderDateFilter?.addEventListener('change', function() {
    addOrUpdateQueryParam('datefilter', orderDateFilter.value);
});
